// extracted by mini-css-extract-plugin
module.exports = {"item":"GovStakeInfo_item__3PmFT"};